/**
 * @author Gustavo Jimenez <soygus@gmail.com>
 */
import React from "react";
import PropTypes from "prop-types";

const ImageLoader = (props) => {
  const {
    classname,
    imgRef,
    image,
    text,
    alt,
    onLoad,
    textColor,
  } = props;

  return (
    <div ref={imgRef} className={classname}>
      <img
        alt={alt}
        onLoad={onLoad && onLoad}
        className="content-image"
        src={image.src}
        srcSet={image.srcSet}
        draggable="false"
      />
      {text && (
        <div
          className={`photoText ${classname === "after" && "afterText"}`}
          style={{ color: textColor }}
        >
          {text}
        </div>
      )}
    </div>
  );
};

ImageLoader.propTypes = {
  classname: PropTypes.string,
  imgRef: PropTypes.oneOfType([
    PropTypes.func,
    PropTypes.shape({ current: PropTypes.instanceOf(Element) }),
  ]),
  image: PropTypes.object,
  text: PropTypes.string,
  textColor: PropTypes.string || undefined,
  alt: PropTypes.string,
  onLoad: PropTypes.func,
};

ImageLoader.defaultProps = {
  textColor: "black",
};

export default ImageLoader;
